module.exports = __webpack_public_path__ + "static/fonts/Fact-ExpandedExtraBold.ef93a1b.eot";